<template>
  <pp-container fluid>
    <p>
      It appears you may already be checked in to the waiting room in another window/tab. Please navigate to that window or tab to continue.
    </p>
    <p>If that's not the case, please check in again.</p>
    <pp-button
      text="Return to Check-in"
      type="primary"
      @click="checkIn"
    />
  </pp-container>
</template>

<script>
import { LOCAL_STORAGE_CHANNEL_ID_KEY } from '@/constants'

export default {
  name: 'ViewsVerify',
  methods: {
    checkIn () {
      localStorage.removeItem(LOCAL_STORAGE_CHANNEL_ID_KEY)

      this.$ppAnalytics.trackEvent({
        action: 'return_to_check_in_from_verify'
      })

      // redirect back to view checkin with the query params
      this.$router.push({ name: 'ViewsCheckIn', query: this.$route.query })
    }
  }
}
</script>
